<template>
  <div class="sectionOuterBox bgBlue">
    <v-container class="container sectionContainer errorSectionContainer" tag="section" aria-labelledby="error-title" aria-describedby="error-description">
      <v-row>
        <v-col cols="12">
          <div class="sectionHeader errorSectionHeader">
            <h1 class="errorTitle" id="error-title">{{ $t('error.pageNotFound') }}</h1>
            <h2 class="errorSubtitle">
              {{ $t('error.pageNotFoundTitle') }}
            </h2>
            <div class="errorDescription" id="error-description">
              {{ $t('error.pageNotFoundDescription') }}
            </div>
            <div class="mt-6">
                <v-btn
                  class="errorButton"
                  color="white"
                  depressed
                  :aria-label="$t('error.goBackAriaLabel')"
                  @click="goHome"
                >
                  {{ $t('error.goBack') }}
                </v-btn>
              </div>
          </div>
        </v-col>
        <v-col class="errorImageContainer" cols="12">
          <img class="errorImage" :src="currentErrorImageSrc" alt="">
        </v-col>
    </v-row>
    </v-container>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import { seasonalImages, tawImages } from '@/constants';
import DateTimeUtils from '@/utils/date-time-utils';
import moment from 'moment-timezone';

@Component
export default class NotFound extends Vue {
  get currentErrorImageSrc() {
    if (moment().isSameOrAfter(moment('2023-07-01', 'YYYY-MM-DD'))) {
      const current = moment();
      const tawDay = DateTimeUtils.getTawDay(current);

      if (tawDay !== -1) {
        return `https://cdn.planbook.com/${tawImages[tawDay]}`;
      }

      for (var i in this.seasonalImages) {
        const si = this.seasonalImages[i];
        const start = moment(`${si.start} 00:00:00`, 'MM-DD HH:mm:ss');
        const end = moment(`${si.end} 23:59:59`, 'MM-DD HH:mm:ss');

        if (current.isBetween(start, end, null, '[]')) {
          return `https://cdn.planbook.com/${si.src}`;
        }
      }
      return 'https://cdn.planbook.com/images/welcome-home-c.png';
    } else {
      return 'https://cdn.planbook.com/images/seasonal/welcome-home-beta-v12.png';
    }
  }

  get seasonalImages() {
    return seasonalImages;
  }

  goHome() {
    window.location.href = '/';
  }
}
</script>

<style lang="scss">
.sectionOuterBox {
  position: relative;
  width: 100%;
  min-height: 100vh;
  font-family: Raleway, Roboto, Arial, Helvetica, sans-serif;
  color: #ffffff;

  &.bgBlue {
    background: #0057c1;
    background-image: url('https://cdn.planbook.com/images/welcome-home-blue-w-2.jpg');
    background-size: cover;
    background-position: center;
  }
}

.sectionInnerBox {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.errorSectionContainer {
  min-height: 100vh;
  display: flex;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 33px 30px;
}

.errorSectionHeader {
  text-align: center;
  margin-bottom: 2rem;

  .errorTitle {
    font-size: 5rem;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 1rem;
    line-height: 1.1;
  }

  .errorSubtitle {
    font-size: 3rem;
    font-weight: 300;
    color: #ffffff;
    margin-bottom: 1rem;
    line-height: 1.3;
  }

  .errorDescription {
    font-size: 1.51rem;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.5;
    margin-bottom: 1.5rem;
    margin-left: auto;
    margin-right: auto;
  }

  .errorButton {
    text-transform: none;
    font-weight: 600;
    padding: 10px 24px;
    border-radius: 8px;
    transition: all 0.3s ease;
    color: #0057c1;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 20px rgba(255, 255, 255, 0.3);
    }

    // WCAG 2.4.7 Focus Visible compliance
    &:focus {
      outline: 2px solid #ffffff;
      outline-offset: 3px;
      box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);
    }

    &:focus-visible {
      outline: 2px solid #ffffff;
      outline-offset: 3px;
      box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);
    }
  }
}

.errorImageContainer {
  text-align: center;
  margin-bottom: 1rem;
}

.errorImage {
  max-width: 100%;
  height: auto;
  max-height: 350px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
  }
}

@media (max-width: 960px) {
  .errorSectionHeader {
    margin-bottom: 1.5rem;

    .errorTitle {
      font-size: 2.5rem;
      margin-bottom: 0.8rem;
    }

    .errorSubtitle {
      font-size: 1.3rem;
      margin-bottom: 0.8rem;
    }

    .errorDescription {
      font-size: 1rem;
      margin-bottom: 1rem;
    }
  }

  .errorImage {
    max-height: 280px;
  }
}

@media (max-width: 600px) {
  .errorSectionHeader {
    margin-bottom: 1rem;

    .errorTitle {
      font-size: 2rem;
      margin-bottom: 0.6rem;
    }

    .errorSubtitle {
      font-size: 1.1rem;
      margin-bottom: 0.6rem;
    }

    .errorDescription {
      font-size: 0.9rem;
      margin-bottom: 1rem;
    }
  }

  .errorImage {
    max-height: 200px;
  }
}
</style>
